import { normalizeValue } from '@dte/otw-utils-core/src/strings/normalizeValue';
import { truncateString } from '@dte/otw-utils-core/src/strings/truncate';

export function normalizeGLN(value: string | undefined): string {
	let normalized = normalizeValue(value) ?? '';

	// Strip everything non-numeric
	normalized = normalized.replace(/[^0-9]/g, '');

	normalized = truncateString(normalized, 12);

	return normalized;
}

export function formatGLN(value: string): string {
	const formatted = normalizeGLN(value);

	// If less than 6 characters, just return the normalized value
	if (formatted.length <= 6) {
		return formatted;
	}

	// If more than 12 characters, combine the parts with a -
	const glnx = formatted.slice(0, 6);
	const glny = formatted.slice(6);
	return `${glnx}-${glny}`;
}
